exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-home-jsx": () => import("./../../../src/templates/Home.jsx" /* webpackChunkName: "component---src-templates-home-jsx" */),
  "component---src-templates-other-pages-jsx": () => import("./../../../src/templates/OtherPages.jsx" /* webpackChunkName: "component---src-templates-other-pages-jsx" */)
}

